import { UrqlGqlLimitedUniversal } from '@pypestream/api-services/urql.limited-access.universal';
import { smartService } from './xstate/smart.xstate';
import {
  setGqlSdk,
  setSmartServiceConfig,
  type SmartServiceConfig,
} from './gql-sdk';

export type { SmartServiceConfig } from './gql-sdk';
export { getGqlSdk, getSmartServiceConfig } from './gql-sdk';

export function initSmartService(config: SmartServiceConfig): void {
  if (
    !config?.endpoints?.gql ||
    !config?.endpoints?.wss ||
    !config?.endpoints?.kratos
  ) {
    throw new Error(
      '@pypestream/design-system: initSmartService requires endpoints.gql, endpoints.wss, and endpoints.kratos'
    );
  }

  setSmartServiceConfig(config);

  const client = new UrqlGqlLimitedUniversal(
    config.endpoints.gql,
    config.endpoints.wss,
    config.endpoints.kratos
  );
  setGqlSdk(client.getGqlClientSdk());

  if (!smartService.initialized) {
    smartService.start();
  }

  smartService.send({
    type: 'configure',
    config,
  } as never);
}
